import { useEffect } from 'react';
import { useEventCallback } from '@cian/react-utils';
import { getQueryObject } from './utils';

export const usePopstateEventQuery = (callback: (queryParams: { [key: string]: string }) => void) => {
  const wrappedCallback = useEventCallback(callback);

  useEffect(() => {
    const listener = () => {
      wrappedCallback(getQueryObject(location.search));
    };

    window.addEventListener('popstate', listener);

    return () => window.removeEventListener('popstate', listener);
  }, [wrappedCallback]);
};
